import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jquislider',
	templateUrl:'./JQUISliderPluginCompPage.html',
	styles: [],
	styleUrls:['./JQUISliderPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUISliderPluginCompPage
{
	mdContent_1021 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.slider.JQUISlider;
\`\`\``;
	mdContent_1022 = `\`\`\`java
JQUISlider()
\`\`\``;
	mdContent_1023 = `\`\`\`java
JQUISlider&lt;?&gt; slider = new JQUISlider&lt;&gt;();
slider.getOptions().setMin(0);
slider.getOptions().setMax(100);
slider.getOptions().setStep(5);
slider.getOptions().setRange(true);
\`\`\``;
}
